import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://79a7ac82d24185abb2a8f0411195e496@o4509197598457856.ingest.us.sentry.io/4509911736254464",
  sendDefaultPii: true
});

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import './index.css'
import App from './App.jsx'

import store from './redux/store';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let payload = urlParams.get('payload');

if (payload[payload.length - 1] === '/') { 
  payload = payload.slice(0,-1);
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App payload={payload} />
    </Provider>
  </React.StrictMode>
);
